import parallax from '../tools/parallax';
import { getterTypes } from '@/types';
const selector = '.post--header .element__fullimage';
export default {
	/**
	 * init custom parallax lib for parallaxing image of Header
	 */
	init() {
		(this.parallax || []).forEach(r => r.destroy());

		const imageElements = Array.from(this.$el.querySelectorAll(selector));
		this.parallax = imageElements.map(imageEl => {
			const wrapper = imageEl.closest('.wrapper--article');

			return parallax({
				element: imageEl,
				container: this.$store.getters[getterTypes.pageTransitionSwipe] ? wrapper : window,
			});
		});
		[...this.$el.getElementsByClassName('post--header')].forEach(post => {
			[...post.getElementsByClassName('post__wrapper')].forEach(wrapper =>
				wrapper.setAttribute('aria-hidden', true)
			);
			const headline = post.querySelector('.post__wrapper--text > .element--headline');
			const text = post.querySelector('.post__wrapper--text > .element--text');
			post.setAttribute(
				'aria-label',
				`${headline ? headline.textContent : ''}\n${text ? text.textContent : ''}`
			);
			post.setAttribute('role', 'text');
			post.setAttribute('tabindex', 0);
		});
	},
	destroy() {
		(this.parallax || []).forEach(r => r.destroy());
		this.parallax = [];
	},
};
